import React, { useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DeleteOutlined, EditOutlined } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import AlertDialog from './Alertdialog';
import { useNavigate } from 'react-router-dom';

const OnboardingSummaryCard = ({
  key = null,
  data = {},
  onAddRole = () => {},
  onEditFirm = () => {},
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = (confirmed) => {
    setDialogOpen(false);
  };

  const handleConfirmAction = () => {
    dispatch({
      type: 'REMOVE_FIRM',
      data: data,
    });
    dispatch({
      type: 'PARTIAL_RESET_FIRM_ONBOARDING_REDUCER',
    });
    setDialogOpen(false);
    navigate('/FetchFirmDetail');
  };
  return (
    <Box
      key={key}
      sx={{
        width: '100%',
        my: '1rem',
      }}
    >
      <AlertDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        title='Confirm Action'
        message='Are you sure you want to edit GSTIN/PAN ?'
        onConfirm={handleConfirmAction}
      />
      <Accordion variant='transparent'>
        <AccordionSummary
          variant='transparent'
          expandIcon={<ExpandMoreIcon color='white' />}
          sx={{
            py: 1,
          }}
        >
          <Stack
            spacing={4}
            direction={'row'}
            alignItems={'center'}
          >
            <Typography
              color={'white'}
              fontSize={'1rem'}
              fontWeight={'bold'}
              sx={{ mr: 1 }}
            >
              {data.firm_name}
            </Typography>
            <Tooltip title='Remove Firm'>
              <IconButton
                aria-label='Remove Firm'
                onClick={() => {
                  dispatch({
                    type: 'REMOVE_FIRM',
                    data: data,
                  });
                }}
              >
                <DeleteOutlined sx={{ color: 'whitesmoke' }} />
              </IconButton>
            </Tooltip>
          </Stack>
        </AccordionSummary>
        <AccordionDetails>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            <Typography color={'white'}>
              {data.document_type === 'GSTIN' ? 'GSTIN' : 'PAN'}
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <Tooltip title={data.firm_adddress}>
                <Typography color={'white'}>{data.document_id}</Typography>
              </Tooltip>
              <Tooltip title={'Edit GSTIN/PAN'}>
                <IconButton onClick={handleOpenDialog}>
                  <EditOutlined sx={{ color: 'whitesmoke' }} />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            <Typography color={'white'}>
              {data.document_type === 'GSTIN' ? 'PAN' : 'GSTIN'}
            </Typography>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <Typography color={'white'}>
                {data.document_type === 'GSTIN'
                  ? data?.pancard_no
                  : data?.gst_no}
              </Typography>
              <Tooltip title={'Edit GSTIN/PAN'}>
                <IconButton onClick={handleOpenDialog}>
                  <EditOutlined sx={{ color: 'whitesmoke' }} />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              mt: 1,
              mb: 1,
            }}
          >
            <Typography
              color={'white'}
              fontWeight={'bold'}
              sx={{ textDecoration: 'underline' }}
            >
              Supplier Company
            </Typography>
            <Typography
              color={'white'}
              fontWeight={'bold'}
              sx={{ textDecoration: 'underline' }}
            >
              Role
            </Typography>
          </Box>
          {Object.keys(data.roles).map((key) => (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography color={'white'}>
                {' '}
                {data.roles[key].manufacturer_name}
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <Typography color={'white'}>
                  {data.roles[key].role_name}
                </Typography>
                <Tooltip title='Remove Role'>
                  <IconButton
                    aria-label='Remove Role'
                    onClick={() => {
                      dispatch({
                        type: 'REMOVE_ROLE',
                        data: {
                          firm: data,
                          role: data.roles[key],
                        },
                      });
                    }}
                  >
                    <DeleteOutlined sx={{ color: 'whitesmoke' }} />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
          ))}
          <Stack
            spacing={2}
            direction={'row-reverse'}
            alignItems={'center'}
            alignContent={'center'}
            sx={{
              mt: 1,
            }}
          >
            <Tooltip title='Add new Roles'>
              <Button
                variant='outlined'
                onClick={onAddRole}
              >
                Add Role
              </Button>
            </Tooltip>
            <Tooltip title='Edit Firm Details if required'>
              <Button
                variant='outlined'
                onClick={onEditFirm}
              >
                Edit Firm Details
              </Button>
            </Tooltip>
          </Stack>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default OnboardingSummaryCard;
